module.exports = __webpack_public_path__ + "img/ecse.7c383fe6.png";